import React, { useState, useEffect } from 'react';
import styles from './subjectsDetailComment.module.scss';
import { Skeleton } from 'antd-mobile-v5'
import { ApiCore } from '../../api/index';
import { ActivityIndicator} from 'antd-mobile';
import utils from '../../utils/utils';
import VisitFormComment from '../visitFormComment/visitFormComment';
import CommentContent from './commentContent/commentContent';
const api = new ApiCore();

function SubjectsDetail(props: any) {
    const urlParams = utils.getUrlParams();
    //选择的项目
    const [projectType, setProjectType] = useState<any>(urlParams.projectType || '');
    //受试者数据
    const [subjectsData, setSubjectsData] = useState<any>({});
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //显示表单（当前只有一个节点时）
    const [showVisitForm, setShowVisitForm] = useState<Boolean>(false);
    //是否展开
    const [commentExpand, setCommentExpand] = useState<Boolean>(false);
    //受试者名称
    const targetName = sessionStorage.getItem('targetName') || '受试者';
    useEffect(() => {
    }, [])

    useEffect(() => {
        //设置网页title
        if (projectType === 'VIDEOSOLICIT') {
            document.title = '任务详情';
        } else if (projectType === 'COURSESOLICIT') {
            document.title = '课程详情';
        } else if (projectType === 'CASESOLICIT') {
            document.title = '病例详情';
        } else if (projectType === 'QUESTIONSURVEY') {
            document.title = '问卷详情';
        } else {
            // LISTEDSTYDY
            document.title =`${targetName}首页`;
        }
        initData();
    }, [])

    // 初始化数据
    const initData = () => {
        setLoading(true);
        api.GetSubjectDetail(props.match.params.id).then((res: any) => {
            if (res.code == 0) {
                sessionStorage.setItem('comment_visits', JSON.stringify(res.data.visits));
                setSubjectsData(res.data);
                setShowVisitForm(true);
                setLoading(false);
            }
        });
    }

    // 评论展开缩起
    const updateExpand = (val: any) => {
        if (val) {
            // 展开
            setCommentExpand(val);
        } else {
            // 缩起
            const scrollEl = document.getElementById('subject_detail_comment');
            scrollEl && scrollEl.scrollIntoView && scrollEl.scrollIntoView({behavior: "smooth"});
            setTimeout(() => {
                setCommentExpand(val);
            }, 700)
        }

    }
    
    return (
        <div className={styles.subjectsDetail_content}>
            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
            <div className={`${styles.list_content} ${commentExpand ? styles.list_content_expand : ''}`}>
                <div id='subject_detail_comment' className={`${styles.list} ${commentExpand ? styles.list_expand : ''}`}>
                {
                    !showVisitForm &&
                    <>
                        <Skeleton.Title animated />
                        <Skeleton.Paragraph lineCount={15} animated />
                    </>
                }
                {
                    showVisitForm && 
                    <div className={styles.visit_form_wrapped}>
                        <VisitFormComment inPrePage={true} {...props} subjectData={subjectsData} />
                    </div>
                }
                </div>
                <div className={styles.comment}>
                    <CommentContent subjectCode={subjectsData.code} updateExpand={ (val: any) => {  updateExpand(val) }} />
                </div>
            </div>
        </div>
    )
}

export default SubjectsDetail;